import PropTypes from "prop-types";
import { Button, Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";

export const CustomToolbar = ({ title, onClickAction, t }) => (
  <Tooltip title={title}>
    <Button variant="outlined" color="primary" onClick={onClickAction} startIcon={<Add />}>
      {t("register")}
    </Button>
  </Tooltip>
);

CustomToolbar.propTypes = {
  title: PropTypes.string,
  onClickAction: PropTypes.func,
  t: PropTypes.func.isRequired,
};
